import React from 'react';
import UIComponent from 'components/UiComponent';
import RatingScale from './RatingScale';
import ProceduresFormContext from '../../../components/context';
import RatingScaleLegend from './RatingScaleLegend';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {withTranslation} from "react-i18next";
import config from 'root/../config';
const moment = require('sis_ui/../vendor/moment.js');

class Question extends React.Component {
    static contextType = ProceduresFormContext;

    constructor(props) {
        super(props);
        this.state = {
            showLegend: false
        }

        this.QUESTION_DATA = this._processQuestionData(this.props.question.DATA);
        this.QUESTION_TYPE_CODE = this.props.question.QUESTION_TYPE_CODE;
        if (["RADIO_BUTTON","CHECKBOX","SELECT_BOX"].indexOf(this.QUESTION_TYPE_CODE) >= 0 && this.QUESTION_DATA.length == 0) {
            this.QUESTION_TYPE_CODE = "COMMENTS";
        }

    }

    _updateAnswer(setValue,value="") {
        if(this.QUESTION_TYPE_CODE === "DATE_PICKER"){
            // STANDARD DATE FORMAT : MM-DD-YYYY (as it's used in the desktop version of the app)
            setValue(this.props.question.QUESTION_CD, moment(value).format('MM-DD-YYYY').toString());
            return;
        }
        return (element) => {
            switch (this.QUESTION_TYPE_CODE) {
                case "RATING_SCALE":
                    setValue(this.props.question.QUESTION_CD, element);
                    break;
                case "RADIO_BUTTON":
                case "CHECKBOX":
                case "SELECT_BOX":
                    setValue(this.props.question.QUESTION_CD, element.VALUE.join(','));
                    break;
                default:
                    setValue(this.props.question.QUESTION_CD, element.target.value);
                    break;
            }
        }
    }

    _toggleLegend() {
        this.setState({
            showLegend: !this.state.showLegend,
        })
    }

    _buildSelectDescriptions(answer) {
        let selectDescription = [];
        let value = answer;
        if (value && value != "") {
            if (!Array.isArray(value)) {
                value = value.toString().split(',');
            }
            value.map((val) => {
                this.QUESTION_DATA.map((result, key) => {
                    if (result.ANSWER_CD == val) {
                        selectDescription.push(result.ANSWER_DESC);
                    }
                })
            });
        } 
        return selectDescription;
    }

    _buildQuestionHeader(){
        if (this.props.question) {
            if(this.props.question.QUESTION_DESC && this.QUESTION_TYPE_CODE != "GENERAL_TEXT"){
                this.setState({ questionHeader: <div className="question-container__header bg-secondary">{this.props.question.QUESTION_DESC} {this.props.question.required ? <span>({this.props.t("lbl.REQUIRED")})</span> : null}</div> })
            }
        }
    }

    _processBlur(setValue){
        return (event) => {
            event.persist();
            this._updateAnswer(setValue)(event);
            this.context.handleQuestionFocus(null);
        }
    }

    _processFocus() {
        if (!this.context.readOnlyForm) {
            this.context.handleQuestionFocus(this.props.question.QUESTION_CD);
        }
    }

    _processQuestionData() {
        if (Array.isArray(this.props.question.DATA) && this.props.question.QUESTION_TYPE_CODE == "SELECT_BOX") {
            return this.props.question.DATA.reduce((acc,value) => {
                let newAcc = acc;
                if (value.ANSWER_CD != "") {
                    newAcc.push(value);
                }
                return newAcc;
            },[]);
        } else {
            return this.props.question.DATA;
        }
    }

    _processDatePickerValue(value) {
        let processedDate = moment(new Date(value)).format(config.dateFormat.momentDateFormat);
        if(processedDate === "Invalid date") {
            //another try -the date comes with the next format -> MM-DD-YYYY
            // some browsers (like Safari on iOS) doesn't support the MM-DD-YYYY date format and returns Invalid date
            // Split the string by the dash (-) and rearrange it to YYYY-MM-DD
            let parts = dateStr.split('-');
            let formattedDateStr = `${parts[2]}-${parts[0]}-${parts[1]}`;
            processedDate = moment( new Date(formattedDateStr)).format(config.dateFormat.momentDateFormat);
        }

        return processedDate;
    }

    _processDatePickerValue(value) {
		let processedDate = moment(value).format(config.dateFormat.momentDateFormat);

		if (processedDate === "Invalid date") {
			//another try -the date comes with the next format -> MM-DD-YYYY
			// some browsers (like Safari on iOS) doesn't support the MM-DD-YYYY date format and returns Invalid date
			// Split the string by the dash (-) and rearrange it to YYYY-MM-DD
			
			let parts = value.split('-');
			
			if (parts.length === 3) {
				let formattedDateStr = `${parts[2]}-${parts[0]}-${parts[1]}`;
				processedDate = moment(formattedDateStr).format(config.dateFormat.momentDateFormat);
			} else {
				return 'Invalid date'; // Handle cases where the date is not formatted properly
			}
		}

		return processedDate;
	}

    render() {

        const {t} = this.props;

        return (
            <React.Fragment>
                {["FORM_DISABLER"].indexOf(this.QUESTION_TYPE_CODE) < 0 &&
                    <div
                        id={"question-" + this.props.question.QUESTION_CD}
                        className={`question-container shadow-depth-1
                            ${this.context.focusedQuestionId == this.props.question.QUESTION_CD ?
                                ""
                                :
                                this.context.focusedQuestionId != null ?
                                    "reduce-opacity-3"
                                    :
                                    ""
                            }
                            {this.QUESTION_TYPE_CODE.toLowerCase()}
                        `}
                        data-id={this.props.question.QUESTION_CD}
                    >
                        {this.props.question.QUESTION_DESC && ["GENERAL_TEXT", "RATING_LEGEND"].indexOf(this.QUESTION_TYPE_CODE) < 0 &&
                            <div className="question-container__header bg-secondary">
                                <span dangerouslySetInnerHTML={{ __html: this.props.question.QUESTION_DESC }}></span> {this.props.question.REQUIRED ? <span>({this.props.t("lbl.REQUIRED")})</span> : null}
                            </div>
                        }
                        <div className="question-container__content">
                            <UIComponent component="smart-form-consumer">
                                    {({setError, values, setValue}) => {
                                        return (() => {
                                            if (this.props.question) {
                                                switch (this.QUESTION_TYPE_CODE) {
                                                    case "GENERAL_TEXT":
                                                        return <div tabIndex="0" dangerouslySetInnerHTML={{ __html: this.props.question.QUESTION_DESC ? this.props.question.QUESTION_DESC : ""}}></div>
                                                    case "RATING_SCALE":
                                                        return (
                                                          <React.Fragment>
                                                            <RatingScale
                                                              data={
                                                                this
                                                                  .QUESTION_DATA
                                                              }
                                                              value={
                                                                values[
                                                                  this.props
                                                                    .question
                                                                    .QUESTION_CD
                                                                ]
                                                              }
                                                              onChange={this._updateAnswer(
                                                                setValue
                                                              ).bind(this)}
                                                              readOnly={
                                                                this.context
                                                                  .readOnlyForm
                                                              }
                                                              hasNA={
                                                                this.props
                                                                  .question
                                                                  .DISPLAYNA !=
                                                                ""
                                                              }
                                                            />
                                                            <span
                                                              tabIndex="0"
                                                              role="button"
                                                              aria-label="legend"
                                                              className="rating-legend-icon"
                                                              onClick={this._toggleLegend.bind(
                                                                this
                                                              )}
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={
                                                                  faInfoCircle
                                                                }
                                                              />
                                                            </span>
                                                            <RatingScaleLegend
                                                              show={
                                                                this.state
                                                                  .showLegend
                                                              }
                                                              onClose={this._toggleLegend.bind(
                                                                this
                                                              )}
                                                              onOpen={this._toggleLegend.bind(
                                                                this
                                                              )}
                                                              data={
                                                                this
                                                                  .QUESTION_DATA
                                                              }
                                                            />
                                                          </React.Fragment>
                                                        );
                                                    case "TEXT_BOX":
                                                        return <UIComponent
                                                            component="smart-input"
                                                            id={"questionField" + this.props.question.QUESTION_CD}
                                                            type={"text"} value={values[this.props.question.QUESTION_CD] ? values[this.props.question.QUESTION_CD] : ""}
                                                            placeholder={t("lbl.TYPE_YOUR_ANSWER","Type Your Answer...")}
                                                            onBlur={this._processBlur(setValue).bind(this)}
                                                            onFocus={this._processFocus.bind(this)}
                                                            readOnly={this.context.readOnlyForm}
                                                        />;
                                                    case "COMMENTS":
                                                        return <UIComponent
                                                            component="smart-textarea"
                                                            id={"questionField" + this.props.question.QUESTION_CD}
                                                            placeholder={t("lbl.TYPE_YOUR_ANSWER","Type Your Answer...")}
                                                            rows={1}
                                                            autoresize={true}
                                                            onBlur={this._processBlur(setValue).bind(this)}
                                                            onFocus={this._processFocus.bind(this)}
                                                            readOnly={this.context.readOnlyForm}
                                                        >{values[this.props.question.QUESTION_CD] ? values[this.props.question.QUESTION_CD] : ""}</UIComponent>;
                                                    case "DATE_PICKER":
                                                        return <UIComponent
                                                            id={"mobile-picker-question" + this.props.question.QUESTION_CD}
                                                            name={"mobile-picker-question" + this.props.question.QUESTION_CD}
                                                            component="datepicker"
                                                            class="inline"
                                                            container={"#question-" + this.props.question.QUESTION_CD}
                                                            value={values[this.props.question.QUESTION_CD] ? this._processDatePickerValue(values[this.props.question.QUESTION_CD]) : ""}
                                                            readOnly={this.context.readOnlyForm}
                                                            onChange={(e,data) => {this._updateAnswer(setValue,data.values)}}
                                                        />
                                                    case "RADIO_BUTTON":
                                                    case "CHECKBOX":
                                                    case "SELECT_BOX":
                                                        return <UIComponent
                                                            component="multiselect"
                                                            name={"questionField" + this.props.question.QUESTION_CD}
                                                            id={"questionField" + this.props.question.QUESTION_CD}
                                                            url={this.props.question.url}
                                                            selectValues={values[this.props.question.QUESTION_CD]}
                                                            selectDescriptions={this._buildSelectDescriptions(values[this.props.question.QUESTION_CD])}
                                                            order="ASC"
                                                            onChange={this._updateAnswer(setValue).bind(this)}
                                                            keyField="ANSWER_CD"
                                                            descField="ANSWER_DESC"
                                                            options={Array.isArray(this.QUESTION_DATA) ? this.QUESTION_DATA : null}
                                                            selectAllOption={true}
                                                            selectAllOptionSingleButton={true}
                                                            showCloseFilterButton={true}
                                                            single={this.QUESTION_TYPE_CODE != "CHECKBOX" ? this.props.question.SINGLE: false}
                                                            readOnly={this.context.readOnlyForm}
                                                            showTitleBar
                                                            title={t("lbl.SELECT_YOUR_ANSWER","Select your answer")}
                                                            naDesc={t("lbl.SELECT","Select")}
                                                            tabIndexContainer = {".dropdown-menu"}
                                                        />
                                                }
                                            }
                                        })()

                                }}
                            </UIComponent>

                            <UIComponent
                                component="smart-form-error-message"
                                id={this.props.question.QUESTION_CD}
                            />
                        </div>
                    </div> 
                }
            </React.Fragment>
        )
    }
}

export default withTranslation()(Question);